/**
 * Footer 社交入口 btn/trackName → 各终端 footer_social.social_entry_XX 坑位固定映射。
 * 编号按各终端页脚 FOLLOW US 图标从左到右的视觉顺序排（01 起）；PC 与 M 的图标顺序
 * 不同，故拆成两套。SDSocialMediaClick 点击上报（FooterV2/index.tsx）与各终端 Footer
 * 变体（2026-pc / 2026-wap）的 Data SPM DOM 打标按终端取表，保证编码同源。
 *
 * 独立成无依赖的小模块：避免变体组件为取这张映射表反向依赖 index.tsx（后者
 * 引入 store / reporting 等重型依赖图，会拖垮纯布局类单测的 mock 清单）。
 */

/** PC 图标左→右：Facebook、YouTube、Instagram、X、Pinterest、TikTok；07 为下方 FB 群组横幅。 */
export const FOOTER_SOCIAL_POSITION_PC: Record<string, string> = {
  fb: 'social_entry_01',
  youtube: 'social_entry_02',
  ins: 'social_entry_03',
  twitter: 'social_entry_04',
  pinterest: 'social_entry_05',
  tiktok: 'social_entry_06',
  fbGroup: 'social_entry_07',
};

/** M 端图标左→右：Instagram、Facebook、TikTok、X、YouTube；06 为 FB 群组入口。 */
export const FOOTER_SOCIAL_POSITION_WAP: Record<string, string> = {
  ins: 'social_entry_01',
  fb: 'social_entry_02',
  tiktok: 'social_entry_03',
  twitter: 'social_entry_04',
  youtube: 'social_entry_05',
  fbGroup: 'social_entry_06',
};

/** 按全局终端取映射：PC 用 PC 顺序；WAP 与 App（表由 WAP 派生）用 WAP 顺序。 */
export function getFooterSocialPositionMap(
  spmPage: 'global_pc' | 'global_wap' | 'global_app',
): Record<string, string> {
  return spmPage === 'global_pc' ? FOOTER_SOCIAL_POSITION_PC : FOOTER_SOCIAL_POSITION_WAP;
}
